import SuperFetch from "../../../utils/superFetch";

export const getMemberProfile = async() =>{
    let response = await SuperFetch('/api/send/profile', 'get')
    return response;
}

export const getAddressSuggestions = async(input) => {
    let response = await SuperFetch(`/api/send/address?query=${input}`, 'get')
    return response 
}

export const getOptimizedRoutes = async(data) => {
    let response = await SuperFetch(`/api/send/getOptimizedRoute`, 'post', data)
    return response 
}

export const getTripFareForDeliveryAddress = async(data) => {
    let response = await SuperFetch(`/api/send/tripFare`, 'post', data)
    return response 
}

export const generateAddressFromCsv = async ( data ) => {
    let response = await SuperFetch(`/api/send/generateAddressFromCsv`, 'post', data)
    return response 
}